import {
  Box,
  Space
} from '@looker/components'

import React, { useContext, useEffect } from 'react'

import _ from 'lodash'
import { useParams } from 'react-router'
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import { ExpandMore } from '@mui/icons-material'
import {Filter} from '../Filter/Filter'

const tagColors = ["#f72c2c61", "#f7c82c61", "#2cf78a61", "#2cb3f761", "#f72ca961"]

export const Filters: React.FC<any> = ({
    data,
    offerings,
    customerCategories,
    marketScopes,
    availabilities,
    certifications,
    currentFilter,
    setCurrentFilter
}) => {  

  const sortList = (list) => {
    if (!list) {
      return []
    }
    return list.sort((a,b) => {
       var x = a.toLowerCase();
       var y = b.toLowerCase();
           return x < y ? -1 : x > y ? 1 : 0;
       });
   }

  return (
    <>
      <Box className='filter-container'>
        <Filter optionLabel={"Product Offerings"} options={sortList(offerings)} setCurrentFilter={setCurrentFilter} currentFilter={currentFilter} name={'supplier_db.product_offerings'}/>
        <Filter optionLabel={"Customer Categories"} options={sortList(customerCategories)} setCurrentFilter={setCurrentFilter} currentFilter={currentFilter} name={'supplier_db.customer_categories'}/>
        <Filter optionLabel={"Availabilities"} options={sortList(availabilities)} setCurrentFilter={setCurrentFilter} currentFilter={currentFilter} name={'supplier_db.availability'}/>
        <Filter optionLabel={"Certifications"} options={sortList(certifications)} setCurrentFilter={setCurrentFilter} currentFilter={currentFilter} name={'supplier_db.certifications'}/>
        <Filter optionLabel={"Market Scopes"} options={sortList(marketScopes)} setCurrentFilter={setCurrentFilter} currentFilter={currentFilter} name={'supplier_db.market_scopes'}/> 
      </Box>    
    </>
  )
}
